import { call, put, select } from "redux-saga/effects";

import actions from "@/actions";
import { MapSettings } from "@/models";

import saveToApi from "../save-to-api/save-to-api";

/**
 * Saves or creates the map floor space settings via the API.
 *
 * @param root0 - The action.
 * @param root0.payload - The settings payload to save.
 * @yields Calls the API and dispatches settings save status.
 */
function* saveSettings({ payload }) {
    try {
        const hasMap = yield select(({ map }) => map.general.settings.hasMap);

        const loadingMessage = hasMap ? "Saving the settings" : "Creating map";
        yield put(actions.window.openLoading(loadingMessage));

        const result = yield call(saveToApi, {
            deleteLuminaires: [],
            luminaireSummary: [],
            floorSpace: payload.convertToAPI(),
        });

        if (!result) {
            return;
        }

        const settings = result.floorSpace;
        yield put(
            actions.map.general.updateSettings(new MapSettings(settings)),
        );
    } catch {
        yield put(
            actions.window.showMessage(
                "We were unable to save any data on this form",
                "error",
            ),
        );
    } finally {
        const visibility = yield select(
            ({ map }) => map.general.settingsModalVisible,
        );
        if (visibility) {
            yield put(actions.map.general.toggleSettingsVisibility());
        }
        yield put(actions.window.closeLoading());
    }
}

export default saveSettings;
